<template>
  <div class="task-official-box">
    <div class="box-shadow">
      <div class="nav-box">
        <span class="go-back" @click="handleCancel">返回列表</span>
        <span class="division"></span>
        <span class="title">{{ titleList[activityType] }}</span>
      </div>
      <div class="task-content">
        <div class="step1-box">
          <div class="step-bar">
            <span class="serial" :style="{ background: globalBG }">1</span>
            <span class="division" :style="{ background: globalBG }"></span>
            <span class="name">筛选任务条件</span>
          </div>
          <el-form
            ref="formSearch"
            :model="formData"
            label-width="164px"
            style="width: 848px; display: inline-block"
          >
            <el-form-item label="任务名称:">
              <el-input
                style="width:648px"
                v-model="formData.activityName"
                :disabled="isCatch"
                placeholder="请输入任务名称"
                size="small"
                maxlength="30"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item label="任务时间:">
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  :disabled="isCatch"
                  v-model="formData.activityStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :picker-options="startTimeOption"
                  @change="moneyPayTimeChange"
                ></el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="formData.activityEndTime"
                  :disabled="isCatch"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 145px; font-size: 12px"
                  class="time2"
                  :picker-options="endTimeOption"
                  :clearable="false"
                  @change="moneyPayTimeChange"
                ></el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  @click="clearTime"
                ></i>
                <img
                  src="@/assets/images/select_date.svg"
                  alt
                  class="date_icon2"
                />
              </div>
            </el-form-item>
            <el-form-item label="发送时间:">
              <span
                v-if="
                  activityType != '1' &&
                  activityType != '4' &&
                  activityType != '5'
                "
                >距离客户最后一次成交</span
              >
              <el-input
                v-if="
                  activityType != '1' &&
                  activityType != '4' &&
                  activityType != '5'
                "
                :disabled="isCatch"
                v-model="formData.lastBuyAfterDays"
                oninput="value=value.replace(/^\.+|[^\d]/g,'')"
                style="width: 80px; padding: 0 8px"
              >
              </el-input>
              <span v-if="activityType == '3' ">~</span>
               <el-input
                v-if="
                  activityType == '3'
                "
                :disabled="isCatch"
                v-model="formData.lastBuyAfterEndDays"
                oninput="value=value.replace(/^\.+|[^\d]/g,'')"
                style="width: 80px; padding: 0 8px"
              >
              </el-input>
              <span
                v-if="
                  activityType != '1' &&
                  activityType != '4' &&
                  activityType != '5'
                "
                style="margin-right: 10px"
                >天时自动发送短信</span
              >
              <span>每日</span>

              <el-time-picker
                v-model="formData.sendTime"
                :disabled="isCatch"
                format="HH:mm:ss"
                value-format="HH:mm:ss"
                :picker-options="sendTimeDate"
                placeholder="选择时间"
                class="day-padding"
                style="margin-left: 8px; width: 136px; margin-right: 10px"
                @change="timeChange"
              ></el-time-picker>

              <span>点发送</span>
              <span class="send-tip">注意：京东人群数据推送时间不固定，建议发送时间设置为下午；</span>
            </el-form-item>
                <!-- <div style="width:1300px;line-height:22px;color:red;margin-top:-16px;margin-bottom:4px;margin-left:92px">
          <div>注意：（1）618大促期间短信发送时间：5月30日-6月15日为8:00-22:00，6月16日-6月17日为8:00-次日01:00，6月18日为00:00-23:59:59，6月19日起恢复正常（即9:00-20:00）。</div>
          <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;（2）5月31日-6月18日京东官方短信频控规则:同一商家2天内给同一手机号发送营销短信条数不超过 1 条;每个手机号每 1 天只能收到 9条京东商家短信,每 2 天只能收到 16条京东商家短信。</div>
          </div> -->
            <el-form-item label="发送对象:">
              <div>
                <!-- {{
                  activityType == "1"
                    ? "人数为昨日新增的,首次成交的客户人数"
                    : "全部成交客户"
                }} -->
                <span v-if="activityType == '1'"
                  >人数为昨日新增的,首次成交的客户人数</span
                >
                <span v-if="activityType == '2' || activityType == '3'"
                  >全部成交客户</span
                >
                <span v-if="activityType == '4'">
                  近
                  <el-input
                    :disabled="isCatch"
                    v-model.number="formData.userActDayStart"
                    style="width: 90px"
                  ></el-input>
                  -
                  <el-input
                    :disabled="isCatch"
                    v-model.number="formData.userActDayEnd"
                    style="width: 90px"
                  ></el-input>
                  天有加购或者关注但无成交的客户
                </span>
                <span v-if="activityType == '5'">
                  开卡满
                  <el-input
                    :disabled="isCatch"
                    v-model.number="formData.userActDayStart"
                    style="width: 90px"
                  ></el-input>
                  天，但从未在店铺下单购买的用户
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="注意：这里开卡满几天不是指满足条件的历史所有用户，而是指那一天的开卡用户。比如 今天是6月18日，设置的满3天，则指的是6月15日开卡入会但是至今从未购买过的用户"
                    placement="right"
                  >
                    <img
                      src="@/assets/images/ask.png"
                      alt=""
                      style="margin-bottom: -2px; cursor: pointer"
                    />
                  </el-tooltip>
                </span>
              </div>
              <div class="tip-box-global">
                <i class="el-icon-warning warning-icon"></i>
                <span
                  >因短信营销接口限制，只有当天可营销人数不低于2人时才会正常执行短信任务</span
                >
              </div>
            </el-form-item>
            <el-form-item label="发送人数:">
              <el-radio-group v-model="formData.isLimitSend" @change="handleLimitSend">
                <el-radio :disabled="isCatch" :label="false">不限制</el-radio>
              
                <el-radio :disabled="isCatch" :label="true">
                限制发送数
                <el-input
                  :disabled="!formData.isLimitSend || isCatch"
                  oninput="if(this.value=='0'){this.value='';}else{this.value=this.value.replace(/[^0-9]/g,'')}"
                  style="width: 68px; margin-right: 8px"
                  v-model="formData.limitSendNum"
                ></el-input>
                <el-tooltip class="item" effect="light"  placement="right-start">
                  <div slot="content" style="color:#666; font-size:12px">
                    <div style="margin-bottom:5px">设置该任务每天发送人数的上限</div>
                    </div>
                  <div class="explain">?</div>
                </el-tooltip>

              </el-radio>
            </el-radio-group>
            </el-form-item>
            <el-form-item label="过滤设置:">
              <el-checkbox-group
                v-model="formData.filterCondition"
                :disabled="isCatch"
                @change="filterCondiions"
              >
                <el-checkbox label="1">
                  <span>屏蔽黑名单</span>
                  <span
                    @click="routerLinkOne()"
                    style="margin-left: 10px; color: #7f85e9"
                    >设置黑名单</span
                  >
                </el-checkbox>
                <el-checkbox label="2">
                  <span>屏蔽近</span>
                  <el-input
                    :disabled="isCatch"
                    v-model.number="formData.filterDays"
                    @keyup.native="limitInput($event)"
                    onblur="value=value.replace(/[^\d]/g,'')"
                    style="width: 100px; padding: 0 6px"
                  >
                  </el-input>
                  <span>天已发送客户</span>
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="选择商品:" v-if="activityType == '1' || activityType == '2'">
              <el-radio-group :disabled="isCatch" v-model="formData.specifyCommodityType" @change="switchSpecify">
                <el-radio :label="0">
                  全部商品
                </el-radio>
                <el-radio :label="1">
                  指定商品
                  <el-button class="search" :disabled="isCatch || formData.specifyCommodityType != '1'"
                   @click="handleShowGoods(true)">已选择{{skuList.length}}个</el-button>
                </el-radio>
                <el-radio :label="2">
                  指定sku
                  <el-input
                    style="width: 280px"
                    @input="limitSkuId"
                    :disabled="formData.specifyCommodityType != '2' || isCatch"
                    v-model="skuIdsStr"
                    placeholder="多个SKU之间用英文逗号隔开"
                  ></el-input>
                </el-radio>
              </el-radio-group>
            </el-form-item>

          </el-form>
        </div>
        <div class="step2-box" style="position: relative">
          <div class="step-bar">
            <span class="serial" :style="{ background: globalBG }">2</span>
            <span class="name" style="margin-left: -10px">发送编辑短信</span>
          </div>
          <el-form
            ref="formSearch"
            :model="formData"
            label-width="75px"
            class="step2FormSearch"
          >
            <el-form-item label="编辑短信:">
              <div class="textarea">
                <el-input
                  type="textarea"
                  style="font-size: 14px; font-family: Microsoft YaHei"
                  :rows="6"
                  placeholder="请输入内容"
                  :disabled="isCatch"
                  v-model="formData.content"
                ></el-input>
                <div class="footInfo">
                  <div>
                    <button
                      class="select"
                      :disabled="isCatch"
                      @click.prevent="templateShow = true"
                    >
                      选择模板
                    </button>
                    <button
                      class="keep"
                      :disabled="isCatch"
                      @click.prevent="handleShowModule"
                    >
                      保存模板
                    </button>
                    <span>
                      已输入
                      <span :style="{ color: globalBG }">{{
                        sendInfoLength
                      }}</span>
                      个字（含签名及退订文字），预计
                      <span :style="{ color: globalBG }">{{
                        Math.ceil(
                          sendInfoLength > 70
                            ? sendInfoLength / 67
                            : sendInfoLength / 70
                        )
                      }}</span>
                      条短信
                    </span>
                  </div>
                  <div>
                    <div class="ask_content">
                      <span class="askContentBox">计费规则</span>
                      <span class="question_icon" style="margin-left: 4px"
                        >?</span
                      >
                      <div class="ask-icon-select">
                        <div>1.70个字计1条短信，超过70字按照67字每条计费。</div>
                        <div>2.一个汉字，字母或标点空格都算作一个字。</div>
                        <div>
                          3.带标签短信以实际发送为准，有可能超过默认字数。
                        </div>
                        <!-- <div>4."签名"包含在字数中。</div> -->
                        <div>4."签名"与"{{ TTip }}"包含在字数中。</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="footTips" style="height: 52px; position: relative">
                <img
                  src="@/assets/images/new_icon_waring_yellow.png"
                  style="
                    display: inline-block;
                    float: left;
                    position: absolute;
                    width: 14px;
                    height: 14px;
                    color: #ffffff;
                    margin: 0px 4px 0 0;
                    top: 9px;
                  "
                />
                <span style="margin-left: 15px; line-height: 21px"
                  >（1）短信中短链必须是最新生成的，不可使用测试短链或是复制其他短链；
                  <br>
                  （2）生成短链后建议复制到手机浏览器打开确保短链接能正常打开。</span
                >
            </div>
            </el-form-item>
            <el-form-item label="短信签名:">
              <div class="btnList">
                <div
                  class="btnBox"
                  v-for="(item, index) in suffixList"
                  :key="index"
                >
                  <el-button
                    class="btn"
                    style="width: auto; font-size: 14px"
                    @click="switchSuffix(index)"
                    :style="{
                      color: selectSuffix == item ? globalBG : '',
                      'border-color': selectSuffix == item ? globalBG : '',
                    }"
                    >{{ item }}</el-button
                  >
                  <span
                    class="check"
                    :style="{
                      'background-color': selectSuffix == item ? globalBG : '',
                    }"
                  >
                    <i class="el-icon-check"></i>
                  </span>
                </div>

                <span
                  @click="goSuffixUrl"
                  style="
                    fontsize: 14px;
                    cursor: pointer;
                    vertical-align: text-bottom;
                  "
                  :style="{ color: globalBG }"
                  >更换</span
                >
              </div>
            </el-form-item>
            <el-form-item label="辅助工具:">
              <div class="tool">
                <p @click.prevent="handleShowShortLink">
                  <i class="iconfont iconbtn_duanwangzhi"></i>插入短网址
                </p>
              </div>
            </el-form-item>
            <el-form-item label="短信测试:">
              <div class="test">
                <el-input
                  v-model="mobiles"
                  placeholder="可输入5个测试号码，以','隔开"
                  class="ipt"
                  style="width: 220px"
                  @input="phoneTest"
                ></el-input>

                <el-button class="sendTest" @click="handleShowSendTip"
                  >发送短信测试</el-button
                >
                <el-button class="record" @click="smsDialogs = true"
                  >短信记录</el-button
                >
              </div>
            </el-form-item>
          </el-form>
          <!-- 短信预览效果 -->
          <div class="xiao-hug xiao_hug2">
            <div style="margin: 0 auto; width: 256px">
              <div
                class="mobile-box"
                :style="{ background: 'url(' + mobileScreen + ') no-repeat' }"
              >
                <div class="message-content" style>
                  【{{ formData.jdSmsSuffix }}】{{ formData.content }}{{ TTip }}
                </div>
              </div>
              <div class="mobile-tips">短信预览效果</div>
            </div>
          </div>
          <footer class="foot">
            <el-button
              type="primary"
              plain
              class="sendTest"
              @click="handleCancel"
              style="width: 148px; height: 36px; margin-right: 10px"
              >取消</el-button
            >
            <el-button
              type="primary"
              :disabled="createLoading || isCatch"
              @click="handleSave"
              style="width: 148px; height: 36px"
            >
              <i v-show="createLoading" class="el-icon-loading"></i>
              保存
            </el-button>
          </footer>
        </div>
      </div>
    </div>

    <!-- 选择模板 -->
    <sms-template
      v-if="templateShow"
      :isShow="templateShow"
      @close="templateChange"
    ></sms-template>

    <!-- 保存模板 -->
    <my-popup
      title="保存模板"
      width="370"
      zIndex="3330"
      :flag="keepTmpShow"
      @close="keepTmpChange"
    >
      <div class="selectBox">
        <div class="headCnt">
          <span>选择栏目：</span>
          <el-select
            v-model="keepTmpValue"
            placeholder="请选择"
            style="width: 240px"
          >
            <el-option
              v-for="(item, index) in dirList"
              :key="index"
              :label="item.title"
              :value="item.tid"
            ></el-option>
          </el-select>
        </div>
        <button class="keepBtn" @click="keepTmpChange(1)">保存模板</button>
      </div>
    </my-popup>

    <!-- 短信记录 -->
    <sms-template2
      :smsDialog="smsDialogs"
      v-if="smsDialogs"
      @transferName="transferName"
      @close="smsDialogClose"
    ></sms-template2>

    <!-- 插入短链接 -->
    <insert-short-dialog
      v-if="insertShortUrlShow"
      :typeSms="smsType"
      @close="handleCloseShort"
    ></insert-short-dialog>

    <!-- 发送确认弹窗 -->
    <el-dialog
      :visible.sync="showSendConfirm"
      title="发送确认"
      append-to-body
      width="450px"
      custom-class="send-con-dialog"
    >
      <div>
        <span>提交号码为 {{ phoneLenght }}</span>
        ，当前短信字数为
        <span :style="{ color: globalBG }">{{ sendInfoLength }}</span>
        字，每条短信以
        <span :style="{ color: globalBG }">{{
          Math.ceil(
            sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70
          )
        }}</span>
        条计费，提交
        <span :style="{ color: globalBG }">{{
          phoneLenght *
          Math.ceil(
            sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70
          )
        }}</span>
        条短信，以实际发送条数为准！
      </div>
      <div class="btn-group">
        <el-button type="primary" @click="handleSendConfirm">发送</el-button>
        <el-button @click="showSendConfirm = false">取消</el-button>
      </div>
    </el-dialog>
      <!-- 选择商品弹窗 -->
      <select-goods
        v-if="isShowGoods"
        :isShow="isShowGoods"
        :selectGoods="skuList"
        :skuSearch="true"
        @close="selectGoodsChange"
        :moduleType="true"
      ></select-goods>
  </div>
</template>

<script>
import selectGoods from "@/components/selectGoodsMonitor2";
import { createMarketing } from "@/api/marketing/autoMarketingO";
import { mapState } from "vuex";
import insertShortDialog from "@/components/insert-short-dialog";
import { preCommit, precisionMarketing, platformSend } from "@/api/smsSend";
import myPopup from "@/components/myPopup";
import smsTemplate from "@/views/serviceCenter/sms_template";
import { getPrecisionJdSuffixList } from "@/api/precisionJdSuffix";
import { getTemplateDir, createTemplate } from "@/api/smsTemplates";
import smsTemplate2 from "@/components/sms-templates-x.vue";
export default {
  name: "create-task-official",
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
    sendInfoLength() {
      return (
        this.formData.content.length +
        this.formData.jdSmsSuffix.length +
        2 +
        this.TTip.length
      );
    },
  },
  props: {
    activityType: {
      type: Number,
      default: 1,
    },
    detailObj: {
      type: Object,
      default: {},
    },
  },
  components: {
    smsTemplate,
    myPopup,
    smsTemplate2,
    insertShortDialog,
    selectGoods
  },
  data() {
    return {
      titleList: [
        "",
        "首单专享礼",
        "复购提醒",
        "客户流失召唤",
        "兴趣客户转化",
        "开卡未购会员转化",
      ],
      smsType: 2, // 官方
      insertShortUrlShow: false, // 插入短链接状态控制 ----- 内容
      mobileScreen: require("@/assets/images/mobileScreen.png"),

      phoneLenght: 0, // 提交号码数量
      showSendConfirm: false,
      smsDialogs: false,
      mobiles: "",
      suffixList: [],
      selectSuffix: "",

      keepTmpShow: false,
      keepTmpValue: "",
      dirList: [],

      TTip: "回T退",
      templateShow: false,
      jdShortLinkList: [],
      // sendInfoLength: 0,
      formData: {
        activityName: "",
        activityStartTime: "",
        activityEndTime: "",
        sendTime: "10:00:00",
        content: "",
        jdSmsSuffix: "",
        filterCondition: [""],
        filterDays: "",
        lastBuyAfterDays: null,
        lastBuyAfterEndDays: null,
        jdShortLink: "", // 短信签名
        userActDayStart: 3,
        isLimitSend:false,
        limitSendNum:'',
        userActDayEnd: 15,
        specifyCommodityType: 0, // 选择商品类型
      },
      createLoading: false,
      isCatch: false, // 是否为查看
      startTimeOption: {
        disabledDate: (date) => {
          var activityEndTime = this.formData.activityEndTime;
          var time = date.getTime();
          var isDisabled = false;
          if (activityEndTime) {
            isDisabled = time > new Date(activityEndTime).getTime();
          }
          if (time < Date.now() - 8.64e7) {
            isDisabled = true;
          }
          return isDisabled;
        },
      },
      endTimeOption: {
        disabledDate: (date) => {
          var activityStartTime = this.formData.activityStartTime;
          var time = date.getTime();
          var isDisabled = false;
          if (activityStartTime) {
            isDisabled = time < new Date(activityStartTime).getTime();
          }
          if (time < Date.now() - 8.64e7) {
            isDisabled = true;
          }
          return isDisabled;
        },
      },
      sendTimeDate: {
        selectableRange: "10:00:00 - 19:55:59",
      },
      skuList: [],
      skuIdsStr: '',
      isShowGoods: false,
    };
  },
  mounted() {
    this.getOfficialSuffix();
    if (this.detailObj.id) {
      // 查看
      this.isCatch = true;
      this.formData = this.detailObj;
      this.formData.filterCondition = [];
      if (this.detailObj.filterBlacklistFlag) {
        this.formData.filterCondition.push("1");
      }
      if (this.detailObj.filterAlreadySentFlag) {
        this.formData.filterCondition.push("2");
      }
      this.TTip;
      var index = this.formData.content.indexOf(this.TTip);
      if (index != "-1") {
        this.formData.content = this.formData.content.substr(0, index);
      }
      var specifyCommodityType = this.detailObj.specifyCommodityType;
      if (specifyCommodityType == '1') {
        this.skuList = this.detailObj.skus;
      } else if (specifyCommodityType == '2') {
        this.skuIdsStr = this.detailObj.skuIds;
      }
    } else {
      if (this.activityType == "2") {
        // 复购
        this.formData.lastBuyAfterDays = 30;
      } else if (this.activityType == "3") {
        // 客户流失召唤
        this.formData.lastBuyAfterDays = 180;
        this.formData.lastBuyAfterEndDays = 180;
        this.formData.isLimitSend = false;
      }
    }
    if (this.isCatch == false) {
      this.dateActive();
    }
  },
  methods: {
    switchSpecify(val) {
      if (val == '1') {
        // 商品弹窗
        this.skuIdsStr = ''
      } else if (val == '2') {
        // sku 
        this.skuList = [];
      } else {
        this.skuIdsStr = '';
        this.skuIdsStr = [];
      }
    },
     // 限制skuid 最多输入30个
    limitSkuId() {
      var value = this.skuIdsStr;
      var reg = /[^\d,\s]/g
       if (reg.test(value)) {
        value = value.replace(reg, "");
      }
     
      this.skuIdsStr = value.replace(/\s+/g, "");
      var limitLength = 30;
      var valueList = value.replace(/[^\d\,]/g, "").split(",");
      if (valueList.length > limitLength) {
        this.skuIdsStr = valueList.slice(0, limitLength).join(',')
      }
    },
    selectGoodsChange(val) {
      // console.log('val:', val)
      if (val) {
        if (val.length > 30) {
          this.$message.warning('sku上限为30个！')
          return
        }
        this.skuList = val;
      }
      this.isShowGoods = false;
    },
    handleShowGoods() {
      this.isShowGoods = true;
    },
    handleLimitSend() {
      this.formData.limitSendNum = ''
    },
    limitInput(event) {
      if (event.target.value == '0') {
        event.target.value = ''
      } else {
        event.target.value = event.target.value.replace(/[^\d]/g,'')
      }
    },
    //时间格式化函数
    dateFormat(time) {
      let date = new Date(time);
      let year = date.getFullYear();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    dateActive() {
      let d = new Date();
      this.formData.activityName =
        this.titleList[this.activityType] +
        this.dateFormat(d.getTime() + 500000);
      this.formData.activityStartTime = this.dateFormat(d.getTime() + 500000);
      this.formData.activityEndTime = this.dateFormat(
        d.getTime() + 86400000 * 30
      );
    },
    // 关闭短链接
    handleCloseShort(val, obj) {
      this.insertShortUrlShow = false;
      console.log(obj);
      if (val) {
        this.formData.jdShortLink = obj.shortLink;
        this.formData.url = obj.originUrl;
        this.formData.content =
          this.formData.content + " " + obj.shortLink + " ";
      }
    },

    handleShowShortLink() {
      if (this.isCatch) {
        return;
      }
      this.insertShortUrlShow = true;
    },
    handleSave() {
      var formData = this.formData;
      var filterCondition = formData.filterCondition;
      var param = {
        activityType: this.activityType,
        filterBlacklistFlag: false,
        filterAlreadySentFlag: false,
        // filterDays: formData.filterDays,
        activityName: formData.activityName,
        activityStartTime: formData.activityStartTime,
        activityEndTime: formData.activityEndTime,
        sendTime: formData.sendTime,
        content: formData.content + this.TTip,
        url: formData.url,
        jdShortLink: formData.jdShortLink,
        jdSmsSuffix: formData.jdSmsSuffix,
        isLimitSend:formData.isLimitSend,
        limitSendNum:formData.limitSendNum,  
      };
      if (!this.formData.content) {
        this.$message.warning("短信内容不能为空哦！");
        return;
      }
      if(this.formData.isLimitSend&&this.formData.limitSendNum<2){
        this.$message.error("限制发送数必须大于大于2");
        return;
      }
      if (this.activityType == "1" || this.activityType == "2") {
        param['specifyCommodityType'] = formData.specifyCommodityType;
        var type = formData.specifyCommodityType;
        if (type == '1') {
          if (!this.skuList || this.skuList.length == '0') {
            this.$message.warning("请选择商品！");
            return;
          }
          // 指定商品
          var skuIds = this.skuList.map(item => {
            return item.skuId
          })
          param['skuIds'] = skuIds.join(',')
        } else if (type == '2') {
          if (!this.skuIdsStr) {
            this.$message.warning("请输入skuId！");
            return
          }
          param['skuIds'] = this.skuIdsStr;
        } else {
          param['skuIds'] = '';
        }
      } else if (this.activityType == "3") {
        console.log();
        if (Number(formData.lastBuyAfterDays)>Number(formData.lastBuyAfterEndDays)&&formData.lastBuyAfterEndDays) {
          this.$message.warning("发送时间天数起始值不能大于结束值");
          return;
        }
        if (!formData.lastBuyAfterDays&&!formData.lastBuyAfterEndDays) {
          this.$message.warning("发送时间必填一个起始值和结束值");
          return;
        }
         param.lastBuyAfterEndDays = formData.lastBuyAfterEndDays;
      } else if (this.activityType == "4") {
        if (
          formData.userActDayStart <= 0 ||
          formData.userActDayEnd <= 0 ||
          formData.userActDayEnd < formData.userActDayStart
        ) {
          this.$message.warning("发送对象的时间无效");
          return;
        }
        param.userActDayStart = formData.userActDayStart;
        param.userActDayEnd = formData.userActDayEnd;
      } else if (this.activityType == "5") {
        if (formData.userActDayStart <= 0) {
          this.$message.warning("发送对象的时间无效");
          return;
        }
        param.userActDayStart = formData.userActDayStart;
        param.userActDayEnd = formData.userActDayStart; //暂时用开始值
      }
      var content = this.formData.content;
      var jdLink = this.formData.jdShortLink;
      var regex = new RegExp("3.cn", "g");
      var count = content.match(regex);
      // console.log('count', count)

      if (count && count.length > 1) {
        this.$message.warning("官方插入的短链接不允许超过1个哦！");
        return;
      }

      if (content.indexOf(jdLink) == "-1") {
        this.formData.jdShortLink = "";
        this.formData.url = "";
      }

      if (filterCondition.indexOf("1") != "-1") {
        // 是否过滤黑名单
        param.filterBlacklistFlag = true;
      }
      if (filterCondition.indexOf("2") != "-1") {
        // 是否过滤几天已发送的客户
        param.filterAlreadySentFlag = true;
        param.filterDays = formData.filterDays;
      }
      if (this.activityType != "1") {
        param.lastBuyAfterDays = formData.lastBuyAfterDays;
      }
      this.createLoading = true;
      createMarketing(param).then((res) => {
        this.createLoading = false;
        if (res.code == "1") {
          this.$message.success("创建成功！");
          var obj = {
            refresh: true,
          };
          this.$emit("onClose", obj);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleCancel() {
      this.$emit("onClose");
    },

    // 确认发送弹窗确认按钮
    handleSendConfirm() {
      this.showSendConfirm = false;
      var mobiles = this.mobiles.split(",");
      var dataFrom = 0;
      var sendType = 0;
      var param = {
        dataFrom,
        sendType,
        mobiles,
      };
      preCommit(param).then((res) => {
        if (res.code == "1") {
          var preData = {
            sendObjectCount: res.data.sendObjectCount,
            sendObjectId: res.data.sendObjectId,
          };
          var paramX = {
            content: this.formData.content + this.TTip,
            sendObjectId: res.data.sendObjectId,
            smsSuffix: this.formData.jdSmsSuffix,
            blackFlag: false,
          };
          platformSend(paramX).then((res) => {
            if (res.code == "1") {
              this.$message.success("发送成功");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 测试短信发送前的弹窗提示
    handleShowSendTip() {
      var mobiles = this.mobiles;
      if (!/[\S]+/.test(mobiles)) {
        this.$message.warning("手机号不能为空，请输入正确的手机号 !");
        return;
      }
      // 替换逗号(不论中/英文逗号，都替换成英文逗号)
      mobiles = mobiles.replace(/(,|，)/g, ",");
      // 切换成数组
      var mobleList = mobiles.split(",");
      var mobileArr = [];
      for (var i = 0; i < mobleList.length; i++) {
        if (/^1[3456789]\d{9}$/.test(mobleList[i])) {
          mobileArr.push(mobleList[i]);
        }
      }

      var newMobleArr = [];
      for (var i = 0; i < mobileArr.length; i++) {
        if (newMobleArr.indexOf(mobileArr[i]) == -1) {
          newMobleArr.push(mobileArr[i]);
        }
      }
      if (newMobleArr.length <= 0) {
        this.$message.warning("号码无效，请输入有效号码 !");
        return;
      }
      if (newMobleArr.length > 5) {
        this.$message.warning("测试发送最多只能发送5个有效号码 !");
        return;
      }

      var content = this.formData.content;
      if (content && content.trim().length > 0) {
        this.mobiles = newMobleArr.join(",");
        // this.strLenght = content.length + this.formData.jdSmsSuffix.length;
        this.phoneLenght = this.mobiles.split(",").length;
        this.showSendConfirm = true;
      } else {
        this.$message.warning("短信内容不能为空哦！");
      }
    },
    transferName() {
      this.smsDialogs = false;
    },
    smsDialogClose(data) {
      this.smsDialogs = data;
    },

    // 短信测试的校验
    phoneTest(val) {
      var reg = /[^\d,，\s]/g,
        mobiles = val;
      if (reg.test(mobiles)) {
        mobiles = mobiles.replace(reg, "");
      }
      this.mobiles = mobiles;
    },

    goSuffixUrl() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
      });
      window.open(routeUrl.href, "_blank");
    },

    // 切换短信签名
    switchSuffix(index) {
      if (this.isCatch) {
        return;
      }
      this.selectSuffix = this.suffixList[index];
      this.formData.jdSmsSuffix = this.selectSuffix || "";
    },
    // 短信模板隐藏
    templateChange(val, item) {
      this.templateShow = false;
      console.log("模版选择返回==", val, item);
      if (val == true) {
        this.selectTemplate = item;
        // this.formData.content = this.formData.content + item.content;
        this.formData.jdShortLink = "";
        this.formData.content = item.content;
      }
    },
    handleShowModule() {
      // 保存模板 显示
      var param = {
        type: 0,
      };
      getTemplateDir(param).then((res) => {
        if (res.code == "1") {
          this.dirList = res.data;
          this.keepTmpShow = true;
        }
      });
    },
    // 保存模板隐藏
    keepTmpChange(val) {
      this.keepTmpShow = false;
      // 保存
      if (val == 1) {
        var param = {
          tid: this.keepTmpValue,
          content: this.formData.content,
        };
        createTemplate(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("保存模板成功！");
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 获取官方和系统的的短信签名
    getOfficialSuffix() {
      // 1.系统 2.京东官方签
      getPrecisionJdSuffixList(2).then((res) => {
        if (res.code == "1") {
          this.suffixList = res.data;
          this.selectSuffix = this.suffixList[0];
          this.formData.jdSmsSuffix = this.selectSuffix || "";
        }
      });
    },

    moneyPayTimeChange() {},
    clearTime() {},
    filterCondiions() {},
    timeChange() {},
    routerLinkOne() {
      let routeUrl = this.$router.resolve({
        path: "/manage/manage/share_polite",
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.search {
  color: rgb(254, 77, 69);
  background-color: #ffffff;
  border-radius: 3px;
  border: 1px solid rgb(254, 77, 69);
  font-size: 14px;
  &.is-disabled{
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #C0C4CC;
  }
}
.search:hover {
  color: #ffffff;
  background-color: rgb(254, 77, 69);
  &.is-disabled{
    background-color: #F5F7FA;
    border-color: #E4E7ED!important;
    color: #C0C4CC;
  }
}
.send-tip{
  position: absolute;
  width: 450px;
  color: #fe4d45; 
  padding-left: 10px
}
/deep/ .day-padding input {
  padding-left: 30px !important;
}
.tip-box-global {
  position: relative;
}
/* 发送确认弹窗 */
.send-con-dialog {
  .success-tip {
    text-align: center;
    font-size: 14px;
    color: #333;
    img {
      margin-right: 10px;
      vertical-align: middle;
    }
  }
  .btn-group {
    margin-top: 30px;
    text-align: center;
  }
}
.test {
  font-size: 14px;
  // height: 32px;
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    width: 98px;
    height: 32px;
    cursor: pointer;
  }
  .ipt {
    width: 224px;
    margin: 0 0px 0 8px;
    vertical-align: top;
  }
  .sendTest {
    // color: #FE4D45;
    width: 106px;
    margin-left: 16px;
    color: #fe4d45;
    border-radius: 3px;
    font-size: 14px;
    padding: 5px 12px;
    border: 1px solid #fe4d45;
    background-color: #fff;
    &:hover {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
    &:active {
      color: #fff;
      border: 1px solid #fff;
      background-color: #fe4d45;
    }
  }
  .record {
    margin: 0 24px 0 8px;
    color: #333333;
    font-size: 14px;
    border-radius: 3px;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
}
.box-shadow {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
}
.task-official-box {
  padding: 11px 20px;
  .task-content {
    padding: 20px 27px;
  }
  .nav-box {
    height: 54px;
    line-height: 54px;
    border-bottom: 1px solid #f0f0f0;
    padding-left: 27px;
    .go-back {
      font-size: 14px;
      color: #999999;
      vertical-align: middle;
      cursor: pointer;
    }
    .division {
      display: inline-block;
      vertical-align: middle;
      margin: 0 20px;
      width: 1px;
      height: 20px;
      background: #cccccc;
    }
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #2e3458;
      vertical-align: middle;
      margin-right: 60px;
    }
  }
  .step1-box {
    font-size: 14px;
    color: #333;
    width: 1666px;
    position: relative;
    &::after {
      display: block;
      content: "";
      width: 1px;
      height: 370px;
      background: #dddddd;
      position: absolute;
      top: 27px;
      left: 11px;
    }
  }
  .step2-box {
    position: relative;
    min-height: 600px;
    .step2FormSearch {
      margin-left: 90px;
      width: 700px;
      display: inline-block;
      @media screen and (max-width: 1370px) {
        width: 700px;
        margin-left: 30px;
      }
    }
    &::after {
      display: block;
      content: "";
      width: 1px;
      height: 580px;
      background: #dddddd;
      position: absolute;
      top: 27px;
      left: 11px;
    }
  }
}
.btnList {
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
    cursor: pointer;
  }
  .btnBox {
    display: inline-block;
    position: relative;
    overflow: hidden;
    height: 32px;
    margin-right: 20px;
    .btn {
      width: 114px;
      height: 32px;
      color: #999999;
      border: 1px solid #cccccc;
      padding-left: 15px;
      border-radius: 3px;
      padding-right: 15px;

      cursor: pointer;
    }
    .check {
      position: absolute;
      right: -16px;
      bottom: -16px;
      width: 30px;
      height: 30px;
      border-radius: 50%;
    }
    i {
      position: absolute;
      right: 16px;
      bottom: 15px;
      font-size: 10px;
      color: #fff;
    }
  }
}

/** 步骤条 */
.step-bar {
  background: #fafafa;
  position: relative;
  padding-left: 12px;
  margin-left: 29px;
  margin-bottom: 20px;
  width: -webkit-calc(100% - 80px);
  width: -moz-calc(100% - 80px);
  width: calc(100% - 80px);
  .serial {
    width: 22px;
    height: 22px;
    border-radius: 22px;
    color: #fff;
    line-height: 22px;
    text-align: center;
    display: inline-block;
    line-height: 22px;
    position: absolute;
    left: -29px;
    top: 50%;
    transform: translateY(-50%);
  }
  .division {
    display: inline-block;
    width: 3px;
    height: 14px;
    margin-right: 8px;
    vertical-align: middle;
  }
  .name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    line-height: 32px;
    vertical-align: middle;
  }
}
.textarea {
  box-sizing: border-box;
  padding: 6px 6px 10px;
  width: 100%;
  background: rgba(249, 250, 251, 1);
  border: 1px solid rgba(238, 238, 238, 1);
  border-radius: 2px;
  .footInfo {
    display: flex;
    justify-content: space-between;
    margin-top: 9px;
    font-size: 14px;
    color: #333;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 76px;
      height: 28px;
      outline: none;
      border: none;
      background-color: white;
      border-radius: 2px;
      font-size: 13px;
    }
    div {
      display: flex;
      align-items: center;
    }
    .select {
      cursor: pointer;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      border-radius: 3px;
      background-color: #fff4f4;
      &:hover {
        color: #fe4d45;
        background-color: #ffe5e5;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
    .keep {
      margin: 0 10px 0 8px;
      cursor: pointer;
      color: #ffffff;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
}
.footTips {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding-left: 12px;
  height: 28px;
  background: rgba(255, 250, 238, 1);
  border: 1px solid rgba(255, 185, 94, 1);
  border-radius: 2px;
  color: #333;
  font-size: 13px;
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #7f85e9 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #7f85e9;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;
}
.ask_content {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  margin-right: 2px;
  cursor: pointer;
  .askContentBox {
    font-weight: normal;
    margin-left: 12px;
    color: #7f85e9;
    @media screen and (max-width: 1370px) {
      width: 60px;
    }
  }
  .ask-icon {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    position: relative;
  }

  .ask-icon-select {
    position: absolute;
    bottom: 38px;
    margin-left: -133px;
    display: none !important;
    width: 375px;
    // height: 80px;
    line-height: 20px;
    padding: 20px;
    background-color: #fff;
    text-align: left;
    box-shadow: 0 8px 20px rgba(139, 156, 188, 0.15);
    color: #999999;
    z-index: 1;
  }
  .ask-icon-select:before {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    right: 50%;
    margin-left: -4px;
    top: 100%;
    border-left: 8px solid transparent;
    border-top: 8px solid #fff;
    border-right: 8px solid transparent;
  }
}
.ask_content:hover {
  .ask-icon-select {
    display: block !important;
  }
}
.selectBox {
  text-align: right;
  .headCnt {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .keepBtn {
    width: 98px;
    height: 32px;
    line-height: 30px;
    margin-top: 20px;
    text-align: center;
    background: rgba(254, 77, 69, 1);
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
  }
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
  }
}
.mobile-box {
  position: relative;
  width: 256px;
  margin-top: 21px;
  height: 504px;
  @media screen and (max-width: 1450px) {
    margin-left: -140px;
  }
  @media screen and (max-width: 1370px) {
    margin-left: -234px;
  }
  // background: url("../../assets/images/mobileScreen.png") no-repeat;
  .message-content {
    position: absolute;
    word-wrap: break-word;
    max-height: 250px;
    overflow-y: auto;
    padding: 12px 12px;
    border-radius: 6px;
    width: 210px;
    font-size: 14px;
    background-color: #fafafa;
    line-height: 20px;
    left: 50%;
    margin-left: -104.665px;
    text-align: left;
    top: 25.4%;
  }
}
.mobile-tips {
  margin-top: 12px;
  font-size: 16px;
  text-align: center;
  color: rgba(51, 51, 51, 1);
}
.xiao_hug2 {
  position: absolute;
  top: 50px;
  left: 990px;
}
.foot {
  border-top: 1px solid #f6f6f6;
  margin-top: 140px;
  text-align: center;
  padding: 20px 0;
  // padding-left: 165px;
  // margin-bottom: 30px;
  margin-left: -25px;
  margin-right: -25px;
}
.explain{
  display: inline-block;
  width: 14px;
  height: 14px;
  padding: 3px;
  text-align: center;
  line-height: 6px;
  border-radius: 50%;
  color: #ccc;
  font-size: 12px;
  margin-left: 8px;
  border: 1px solid #ccc;
  cursor: default;
}
.tool {
  display: flex;
  align-items: center;
  p {
    box-sizing: border-box;
    padding: 0 8px;
    margin: 0 8px 0 0;
    font-size: 14px;
    border-radius: 3px;
    background-color: #f7f8fe;
    border: 1px solid #7f85e9;
    color: #7f85e9;
    &:hover {
      background: rgba(174, 179, 241, 0.16);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9 !important;
    }
    &:active {
      background: rgba(174, 179, 241, 0.24);
      border: 1px solid #7f85e9 !important;
      color: #7f85e9;
    }
  }
}
</style>